(ns ncr.manage.preferences
  (:require
   [cljs.core.async :as async :refer-macros [go] :refer [<!]]
   [ncr.etc.alert :as a]
   [ncr.etc.modal :as m]
   [ncr.etc.rhf :as rhf]
   [uix.core.alpha :as uix]
   [ncr.etc.pf :as pf]
   [ncr.etc.profile :as profile]))

(uix/defcontext *context*)

(defn use-experimental?
  ([]
   (get (uix/context *context*) :experimental? false))

  ([feat]
   (let [{:keys [experimental?] :as experimental} (uix/context *context*)]
     (and experimental? (get experimental feat)))))

(defn- c-form [{:keys [submit control]}]
  [:div {:class :ncr-c-settings-form}
   [pf/c-form {:class :ncr-c-settings-form :is-horizontal true :on-submit submit}
    [:<>
     [pf/c-form-group
      {:class :ncr-m-header
       :label "Experimental"
       :helper-text
       [pf/c-form-helper-text {:component :div :is-hidden false}
        "Enable beta features; may change or be removed"]}

      [rhf/c-controller
       {:name :experimental?
        :control control
        :render
        (fn [props]
          [pf/c-switch
           {:class :ncr-c-settings-form__experimental
            :aria-label "Toggle experimental features"
            :is-checked
            (boolean (get-in props [:field :value]))
            :on-change
            (-> props :field :on-change)}])}]]

     [pf/c-form-group
      {:label "Read Clipboard"
       :helper-text
       [pf/c-form-helper-text {:component :div :is-hidden false}
        "Clipboard Read for suggestions. May reveal private data or not work properly outside Chrome."]}

      [rhf/c-controller
       {:name :read-clipboard?
        :control control
        :render
        (fn [props]
          [pf/c-switch
           {:aria-label "Toggle reading clipboard for suggestions"
            :is-checked
            (boolean (get-in props [:field :value]))
            :on-change
            (-> props :field :on-change)}])}]]]]])

(defn- c-modal [default-values]
  (let
    [{:keys [submit] :as form}
     (rhf/use-form
       {:should-focus-error false
        :default-values default-values})]
    [m/c-modal
     {:title "Preferences"
      :variant :medium
      :id :personal-settings-modal
      :actions
      [[pf/c-button
        {:variant :primary
         :on-click submit}
        "Ok"]
       [pf/c-button {:variant :link :on-click #(m/close! nil)}
        "Cancel"]]}
     [c-form form]]))

(def ^:private pspec
  [:remote "ui/preferences/experimental"])

(defn !edit-preferences []
  (go
    (let [preferences (<! (profile/read-profile! pspec {}))]
      (when-let [preferences (<! (m/!modal #'c-modal preferences))]
        (a/!operation {:operation-title "Saving preferences" :success-title "Preferences saved"}
          (profile/write-profile! pspec preferences))))))

(defn c-with-preferences [body]
  (let [preferences (profile/use-profile pspec {})]
    (uix/context-provider [*context* @preferences]
      body)))
